import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import docIcon from './images/docIcon.png';
import Loading from "./loader";
import { Modal, Input, Radio } from 'antd';
import { ArrowLeftOutlined } from "@ant-design/icons";
import { enqueueSnackbar } from "notistack";
import StateWarning from './StateWarning';

const { TextArea } = Input;

class VoteMeetingRedactDocs extends Component {
    state = {
        docs: null,
        isModalTypeVisible: false,
        isModalFormVisible: false,
        selectedDocType: null,
        newDocName: '',
        newDocUrl: '',
    };

    async componentDidMount() {
        const { is_staff, is_superuser, match } = this.props;

        if (!is_staff && !is_superuser) {
            alert("Доступ запрещен");
            window.location.href = `/#/`;
            return;
        }

        if (!match || !match.params || !match.params.meetingId) {
            alert("Не удалось получить ID собрания из URL.");
            window.history.back();
            return;
        }

        const meetingId = match.params.meetingId;
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

        try {
            const userRes = await fetch(`${API_ADDRESS}get_docs/${meetingId}/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            if (userRes.ok) {
                const docsData = await userRes.json();
                this.setState({ docs: docsData });
            } else {
                alert("Произошла ошибка. Попробуйте еще раз открыть раздел.");
                console.error('Ошибка:', userRes.statusText);
                window.history.back();
            }

            if (userRes.statusText === "Unauthorized") {
                alert("Время сессии истекло. Пожалуйста выполните вход.");
                document.getElementById("logoutBttn").click();
            }
        } catch (e) {
            alert("Произошла ошибка. Попробуйте еще раз открыть раздел.");
            console.log(e);
            window.history.back();
        }
    }

    async componentDidUpdate(prevProps) {
        const { is_staff, is_superuser } = this.props;

        if (prevProps.is_staff !== is_staff || prevProps.is_superuser !== is_superuser) {
            if (!is_staff && !is_superuser) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
            }
        }
    }

    handleBackClick = () => {
        window.history.back();
    };

    handleDownload = async (docId) => {
        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        const token = localStorage.getItem('token');

        try {
            const response = await fetch(`${API_ADDRESS}download_doc/${docId}/`, {
                method: 'GET',
                headers: {
                    'Authorization': `JWT ${token}`,
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = '';  // использовать имя из ответа
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            } else {
                enqueueSnackbar('Ошибка при скачивании', { variant: 'error' });
            }
        } catch (e) {
            enqueueSnackbar('Ошибка сети', { variant: 'error' });
        }
    };

    handleAddDoc = () => {
        enqueueSnackbar('В разработке', { variant: 'error' });
        //this.setState({
        //    isModalTypeVisible: true,
        //    selectedDocType: null,
        //    newDocName: '',
        //    newDocUrl: '',
        //});
    };

    handleTypeCancel = () => {
        this.setState({
            isModalTypeVisible: false,
            selectedDocType: null,
            newDocName: '',
            newDocUrl: '',
        });
    };

    handleTypeOk = () => {
        const { selectedDocType } = this.state;
        if (!selectedDocType) {
            enqueueSnackbar('Пожалуйста, выберите тип документа', { variant: 'error' });
            return;
        }
        this.setState({
            isModalTypeVisible: false,
            isModalFormVisible: true,
            newDocName: '',
            newDocUrl: '',
        });
    };

    handleRadioChange = (e) => {
        this.setState({ selectedDocType: e.target.value });
    };

    // === Модальное окно 2: Форма ввода ===
    handleFormCancel = () => {
        this.setState({
            isModalFormVisible: false,
            isModalTypeVisible: true,
        });
    };

    handleFormChange = (field, value) => {
        this.setState({ [field]: value });
    };

    handleSaveDoc = async () => {
        const { match } = this.props;
        const meetingId = match.params.meetingId;
        const { newDocName, selectedDocType, newDocFile } = this.state;

        if (!newDocName.trim()) {
            enqueueSnackbar('Введите наименование', { variant: 'error' });
            return;
        }
        if (!newDocFile) {
            enqueueSnackbar('Выберите файл', { variant: 'error' });
            return;
        }

        const formData = new FormData();
        formData.append('meeting_id', meetingId);
        formData.append('fname', newDocName.trim());
        formData.append('is_result', selectedDocType === 'result');
        formData.append('file', newDocFile);

        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${API_ADDRESS}add_doc/`, {
                method: 'POST',
                headers: {
                    'Authorization': `JWT ${token}`,
                },
                body: formData,
            });

            if (response.ok) {
                const savedDoc = await response.json();
                this.setState(
                    (prevState) => ({
                        docs: [...prevState.docs, savedDoc],
                        isModalFormVisible: false,
                        isModalTypeVisible: false,
                        selectedDocType: null,
                        newDocName: '',
                        newDocFile: null,
                    }),
                    () => enqueueSnackbar('Документ добавлен', { variant: 'success' })
                );
            } else {
                const error = await response.json();
                enqueueSnackbar(error.message || 'Ошибка', { variant: 'error' });
            }
        } catch (e) {
            enqueueSnackbar('Ошибка сети', { variant: 'error' });
        }
    };

    render() {
        const { docs } = this.state;
        const {
            isModalTypeVisible,
            isModalFormVisible,
            selectedDocType,
            newDocName,
            newDocUrl,
        } = this.state;

        if (!docs) {
            return <div><Loading /></div>;
        }

        const allDocs = docs;

        return (
            <>
                <div className="page-container">
                    <div className="header-container">
                        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
                            <div className="back-button-wrapper" onClick={this.handleBackClick}>
                                <ArrowLeftOutlined
                                    style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                                />
                            </div>
                            <h1>Материалы собрания</h1>
                        </div>
                    </div>

                    {allDocs.length > 0 ? (
                        <div className="docs-list">
                            {allDocs.map((doc) => (
                                <div
                                    className="doc-card"
                                    key={doc.id}
                                    onClick={() => this.handleDownload(doc.id)}
                                >
                                    <div className="doc-content">
                                        <b>{doc.fname}</b>
                                        <div className="doc-icon">
                                            <img src={docIcon} alt="док. файл" width="34" height="34"/>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <StateWarning message="Материалы собрания на данный момент отсутствуют"/>
                    )}

                    <div className="button-container5">
                        <button2 className="button2" onClick={this.handleAddDoc}>
                            <b>Добавить</b>
                        </button2>
                    </div>

                    {/* Модальное окно 1: Выбор типа документа */}
                    <Modal
                        title="Выберите тип документа"
                        open={isModalTypeVisible}
                        onOk={this.handleTypeOk}
                        onCancel={this.handleTypeCancel}
                        okText="Далее"
                        cancelText="Отмена"
                    >
                        <Radio.Group
                            onChange={this.handleRadioChange}
                            value={selectedDocType}
                            style={{display: 'flex', flexDirection: 'column', width: '100%'}}
                        >
                            <Radio
                                value="material"
                                style={{
                                    marginBottom: '12px',
                                    padding: '10px',
                                    border: '1px solid #d9d9d9',
                                    borderRadius: '6px',
                                    width: '100%'
                                }}
                            >
                                <b>Материалы</b>
                            </Radio>
                            <Radio
                                value="result"
                                style={{
                                    padding: '10px',
                                    border: '1px solid #d9d9d9',
                                    borderRadius: '6px',
                                    width: '100%'
                                }}
                            >
                                <b>Итоговый протокол</b>
                            </Radio>
                        </Radio.Group>
                    </Modal>

                    {/* Модальное окно 2: Форма ввода */}
                    <Modal
                        title={selectedDocType === 'result' ? "Добавить итоговый протокол" : "Добавить материал"}
                        open={isModalFormVisible}
                        onOk={this.handleSaveDoc}
                        onCancel={this.handleFormCancel}
                        okText="Сохранить"
                        cancelText="Назад"
                    >
                        <div style={{marginBottom: '16px'}}>
                            <div><b>Наименование</b></div>
                            <Input
                                value={newDocName}
                                onChange={(e) => this.handleFormChange('newDocName', e.target.value)}
                                placeholder="Введите наименование"
                            />
                        </div>

                        <div style={{marginBottom: '16px'}}>
                            <div><b>Файл</b></div>
                            <input
                                type="file"
                                onChange={(e) => this.setState({newDocFile: e.target.files[0]})}
                                style={{width: '100%'}}
                            />
                        </div>
                    </Modal>
                </div>
            </>
        );
    }
}

export default withRouter(VoteMeetingRedactDocs);